import { useReactFlow, MarkerType } from "reactflow";
import { EDGE_TYPES } from "constants/flowDesigner";

const useHandleStraightEdge = () => {
  const { setEdges, getEdges } = useReactFlow();

  const createStraightEdge = (sourceNodeId, targetNodeId, runSynchronously = true) => {
    return {
      pathOptions: { offset: 3 },
      deletable: false,
      id: `${sourceNodeId}->straight->${targetNodeId}`,
      target: targetNodeId,
      source: sourceNodeId,
      type: EDGE_TYPES.STRAIGHT,
      markerEnd: { type: MarkerType.ArrowClosed, width: 14, height: 14, color: "#7443FF" },
      style: {
        strokeDasharray: runSynchronously ? "0" : "5,5"
      }
    };
  };

  const addStraightEdge = (sourceNodeId, targetNodeId, runSynchronously = true) => {
    const filteredEdges = getEdges().filter((edge) =>
      edge.source === sourceNodeId ? edge.type !== EDGE_TYPES.STRAIGHT : true
    );

    setEdges(filteredEdges.concat(createStraightEdge(sourceNodeId, targetNodeId, runSynchronously)));
  };

  const deleteStraightEdge = (sourceNodeId) => {
    const filteredEdges = getEdges().filter((edge) =>
      edge.source === sourceNodeId ? edge.type !== EDGE_TYPES.STRAIGHT : true
    );

    setEdges(filteredEdges);
  };

  return {
    addStraightEdge,
    createStraightEdge,
    deleteStraightEdge
  };
};

export default useHandleStraightEdge;
